// node_modules
import { toast } from 'react-hot-toast';
// Enums
import { ToastTypeEnum } from "Enums";
// Components
import { NotificationMessage } from 'Components';
// Types
import { TNotificationMessageDTO } from 'Types';

class ToastHelper {
    public defaultErrorMessage: string = "Something went wrong, please contact us.";

    public showToast(toastType: ToastTypeEnum, message: string): void {
        if (!toastType || !message) toast.error(this.defaultErrorMessage);

        switch (toastType) {
            case ToastTypeEnum.Error:
                toast.error(message);
                break;
            case ToastTypeEnum.Success:
                toast.success(message);
                break;
            case ToastTypeEnum.Notification:
                toast(() => <NotificationMessage message={message} />);
                break;
            default:
                toast.error(this.defaultErrorMessage);
                break;
        }
    }

    public handleNotificationMessage(notificationMessage: TNotificationMessageDTO, currentUserEmail: string): void {
        if (!notificationMessage ||
            (notificationMessage && 
                (!notificationMessage.exclusionList || 
                !notificationMessage.message))) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, ToastHelperSingleton.defaultErrorMessage);
        }

        if (currentUserEmail && !notificationMessage.exclusionList.includes(currentUserEmail.trim().toLowerCase())) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Notification, notificationMessage.message);
        }
    }
}

export const ToastHelperSingleton = new ToastHelper();
